import { rules, type schema } from "@/utils/validators";
import type { loginFormData } from "./types.api";

export const loginSchema: schema<loginFormData> = {
    email: [
        rules.required("El correo electrónico es requerido."),
        rules.isEmail(),
    ],
    password: [rules.required("La contraseña es requerida.")],
};
